import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { GeneralTable, useModalAlert } from "../GeneralComponents";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start", // Vertical centering
    whiteSpace: "pre-wrap", // Tries to keep the text on a single line
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function TableCargos() {
  const classes = useStyles();
  const [listCargos, setListCargos] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const { showModalAlert } = useModalAlert();
  const [openModal, setopenModal] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(true);

  useEffect(() => {
    loadCargos();
  }, [page, pageSize]);

  const loadCargos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `cargo/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const dataRows = data.results.map((row) => ({
          ...row,
          id: row.id_cargo,
        }));
        console.log("lista de cargos", data);
        setListCargos(dataRows);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const handleCloseModal = () => {
    setopenModal(false);
  };

  const columns = [
    {
      field: "cargo",
      headerName: "NOMBRE",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];
  const newModalField = [
    { name: "cargo", label: "Nombres", type: "mayuscula" },
  ];

  async function handleSave(formData) {
    console.log("formData", formData);

    try {
      const url = isEditMode
        ? process.env.REACT_APP_PUBLIC_URL + "cargo/update"
        : process.env.REACT_APP_PUBLIC_URL + "cargo/create";
      const createResponse = await fetch(url, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(formData),
      });
      const result = await createResponse.json();
      loadCargos();
      setIsEditMode(false);
      handleCloseModal();
      if (isEditMode) {
        showModalAlert("success", "Se actualizo correctamente el cargo");
      } else {
        showModalAlert("success", "Se creo correctamente el cargo");
      }
    } catch (error) {
      showModalAlert("danger", "Error al crear el cargo");
      console.error("Error:", error);
    }
  }

  const onActivate = async (row) => {
    try {
      let dataSend = {
        id_cargo: row.id_cargo,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "cargo/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadCargos();
      showModalAlert("success", "Se activo correctamente el cargo");
    } catch {
      showModalAlert("danger", "Error al activar el cargo");
    }
  };

  const onInactivate = async (row) => {
    try {
      let dataSend = {
        id_cargo: row.id_cargo,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "cargo/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadCargos();
      showModalAlert("success", "Se inactivo correctamente el cargo");
    } catch {
      showModalAlert("danger", "Error al inactivar el cargo");
    }
  };

  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Cargos "
        buttonText="Crear Cargo"
        columns={columns}
        rows={listCargos}
        isModalDocument={true}
        width={"25%"}
        modalFields={newModalField}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        onSaveModal={handleSave}
        enableUpdate
        enableActivate
        onActivate={onActivate}
        onInactivate={onInactivate}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        loadList={loadCargos}

      />
    </>
  );
}
